import React from 'react';
import { Link } from 'react-router-dom';
import { Section, SectionHeading } from '../Section';
import { Reveal } from '../Reveal';
import { LinkButton } from '../Button';
import { insights } from '../../data/insights';
import { formatInsightDate } from '../../utils/format';
const latest = insights.slice(0, 3);
export function InsightsPreview() {
  return <Section tone="paper" ariaLabel="Latest insights" data-id="element-93" data-mp="2vkww5j5lxa5r">
      <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-94" data-mp="3j9g39vcx7gw9">
        <SectionHeading eyebrow="Insights" title="What our research desk is writing this month." description="The same notes our advisers work from go to you — unedited, in plain language." data-id="element-95" data-mp="3o784jfzggfd4" />
        <LinkButton to="/insights" variant="outline" data-id="element-96" data-mp="3egmzb9pa0cl8">
          All insights
        </LinkButton>
      </div>

      <ul className="mt-12 border-t border-line" data-id="element-97" data-mp="613b4p3gpkd1">
        {latest.map((insight, index) => <Reveal as="li" key={insight.slug} delay={index * 0.05} className="border-b border-line" data-id="element-98" data-mp="atd7onz31ioa" data-mpi={index}>
            <Link to="/insights" className="group grid gap-3 py-7 transition-colors duration-200 ease-out-quint md:grid-cols-12 md:items-baseline md:gap-6" data-id="element-99" data-mp="nsx5fsplnju">
              <div className="md:col-span-3" data-id="element-100" data-mp="adm586tn7kjc">
                <span className="inline-block rounded-sm border border-gold/35 px-2 py-0.5 text-[0.7rem] font-medium uppercase tracking-wider text-gold-dark" data-id="element-101" data-mp="5m44njvj7lyw">
                  {insight.category}
                </span>
              </div>
              <div className="md:col-span-7" data-id="element-102" data-mp="ede6rzkmcqf7">
                <h3 className="font-serif text-[1.35rem] leading-snug text-charcoal transition-colors duration-200 ease-out-quint group-hover:text-gold-dark" data-id="element-103" data-mp="egilvrzmh6kn">
                  {insight.title}
                </h3>
                <p className="mt-2 max-w-xl text-[0.95rem] leading-relaxed text-charcoal-600" data-id="element-104" data-mp="2v31ugxd7r16v">
                  {insight.excerpt}
                </p>
              </div>
              <div className="text-sm text-charcoal-400 md:col-span-2 md:text-right" data-id="element-105" data-mp="2q5t6uh9aq4y8">
                <p data-id="element-106" data-mp="3ftowdr6e3e6b">{formatInsightDate(insight.date)}</p>
                <p className="mt-1" data-id="element-107" data-mp="3jt63ep1gsjdl">{insight.readMinutes} min read</p>
              </div>
            </Link>
          </Reveal>)}
      </ul>
    </Section>;
}